export interface CustomDashSizeOptionProps {
  dashSize: number;
  className?: string;
  onUpdateDashSize(dashSize: number, undoable?: boolean): void;
}

export const CUSTOM_DASH_MIN_SIZE = 10;
export const CUSTOM_DASH_MAX_SIZE = 100;
